import React, {
  ChangeEvent,
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import style from "./LessonSearchPage.module.css";
import filterIcon from "../../../base/assets/icons/filter.svg";
import addLesson from "../../../base/assets/icons/icon_add_lesson.svg";
import deleteChip from "../../../base/assets/icons/delete_chip.svg";
import Pagination from '@mui/material/Pagination';  
import { Link  , useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { observer } from "mobx-react"; //
import store, { MultipleValueFields } from "../lessonStore";
import Lesson from "./components/Lesson";
import { Chip, SwipeableDrawer } from "@mui/material";
import { useTranslation } from "react-i18next";
import FilterBoxes from "./components/FilterBoxes";
import appStore, { BreadcrumbsDI } from "../../../base/stores/AppStore";
import {
  getArrayFromQueryParam,
  getQueryStringFromObject,
} from "../../../base/services/urlService";
import { Id, ListItem, SelectableDataObjectDI } from "../types";
import useConstructor from "../../../base/hooks/useConstructor";
import lessonStore from "../lessonStore";
import _ from "lodash";
import UserStore from "../../../base/stores/UserStore";
import searchIcon from "../../../base/assets/icons/icons_circle.png";
import DropDownArrow from "../../../base/icons/DropDownArrow";
import delSearchIcon from "../../../base/assets/images/bitmaps/delSearch.png";
import lesson_toOpenIcon from "../../../base/assets/icons/lessons_toOpen.png";
import lesson_toCloseIcon from "../../../base/assets/icons/lessons_toClose.png";
import closeBottomSheetIcon from "../../../base/assets/images/bitmaps/icons_close.png";
import FilterWrapper from "./components/FilterWrapper";
import LessonAddedModal from "./components/LessonAddedModal";
import LessonNotification from "./components/LessonNotification";
import CustomModal from "../../../base/modal/Modal";
import MobileMultDropDown from "../../../base/reusables/mobileMultDropDown/MobileMultDropDown";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "@mui/material";
import closeLabelIcon from "../../../base/assets/icons/close_field.png";
import { useTitle } from "react-use";
import addLessonMobileIcon from "../../../base/assets/images/bitmaps/add_lesson_mobile.png";
import Button from "../../../base/reusables/button/Button";
import SubHeader from "../../../base/sub-header/SubHeader";
import { Box } from "@mui/system";
import Popover from "@mui/material/Popover";
import AppStore from "../../../base/stores/AppStore";
import { Autocomplete, TextField } from "@mui/material";
import dataWrapper from "../../../base/reusables/dataWrapper";

interface checkedItemsArr {
  id: string | number;
  checked: boolean;
}
//  const promises = lessonStore.getLists();
//   const wrapper = dataWrapper(promises);


const LessonsPage = () => {
  const navigate = useNavigate(); 
    //  wrapper.read();
useEffect(() => {
  lessonStore.getLists();
}, []);
  const isEditor = UserStore.user?.isEditor;
  const location = useLocation();
  const searchObject = location.search;
  const searchParams = new URLSearchParams(searchObject);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(0);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [totalLessonsLoaded, setTotalLessonsLoaded] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [containerHeight, setContainerHeight] = useState(0);
  const [mobileFixed, setMobileFixed] = useState(true);

  const containerRef = useRef<HTMLDivElement>(null);
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const mainSwipeableDrawerRef = useRef<HTMLDivElement>(null);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverShowClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id_ = open ? "simple-popover" : undefined;

  const defaultParams = {
    pageNumber: searchParams.get("pageNumber") || "1",
    resultsPerPage: searchParams.get("resultsPerPage") || "5",
    isApproved:
      searchParams.get("isApproved") == "true" ||
      searchParams.get("isApproved") == null
        ? true
        : false,
    freeSearch: searchParams.get("freeSearch") || "",
    projectTypes: getArrayFromQueryParam(searchParams.get("projectTypeId")),
    externalFactorInvolvedId: getArrayFromQueryParam(
      searchParams.get("externalFactorInvolvedId")
    ),
    stepId: getArrayFromQueryParam(searchParams.get("stepId")),
    lessonTags: getArrayFromQueryParam(searchParams.get("lessonTags")),
    organizationalUnitId: getArrayFromQueryParam(
      searchParams.get("organizationalUnitId")
    ),
    fieldId: getArrayFromQueryParam(searchParams.get("fieldId")),
    projectNameId: getArrayFromQueryParam(searchParams.get("projectNameId")),
  };

  const [tags, setTags] = useState<
    Array<{
      checkboxId: Id;
      checkboxText: string;
      fieldName: keyof MultipleValueFields;
    }>
  >([]);
  const [fieldIsOpen, setFieldIsOpen] = useState(false);
  const [fieldDropDownIsOpen, setFieldDropDownIsOpen] = useState(false);
  const [tempFreeSearch, setTempFreeSearch] = useState("");
  const [breadCrumbs, setBreadCrumbs] = useState<BreadcrumbsDI[]>();

  const { t } = useTranslation();
  useTitle(t("General-content-header") + t("Lesson-Search-Header-Title"));
  const {
    lists,
    setSearchBoxFieldValues,
    setIsApproved,
    setFreeSearch,
    resetFields,
    getSearchObject,
    setPageNumber,
    setResultsPerPage,
    numPages,
    search,
  } = store;
  const { multipleValueFields, isApproved, freeSearch, pageNumber } = search;
  const {
    fieldId,
    externalFactorInvolvedId,
    organizationalUnitId,
    projectTypeId,
    lessonTags,
    projectNameId,
    stepId,
    projectPartnerIds,
  } = multipleValueFields;
  const allFields: Array<SelectableDataObjectDI> = [];
  for (let i = 0; i < lists.fieldId.length; i++) {
    let newObj = {
      value: lists.fieldId[i].id,
      text: lists.fieldId[i].name,
      hide: lists.fieldId[i].hide,
    };
    allFields.push(newObj);
  }

  /**
   * The source of truth for the application state is the URL or default values.
   */
  const setValuesFromUrl = () => {
    setFreeSearch(defaultParams.freeSearch);
    setTempFreeSearch(defaultParams.freeSearch);
    setPageNumber(parseInt(defaultParams.pageNumber)); //
    setResultsPerPage(parseInt(defaultParams.resultsPerPage));
    setIsApproved(defaultParams.isApproved);
    setSearchBoxFieldValues("projectTypeId", defaultParams.projectTypes);
    setSearchBoxFieldValues(
      "externalFactorInvolvedId",
      defaultParams.externalFactorInvolvedId
    );
    setSearchBoxFieldValues("stepId", defaultParams.stepId);
    setSearchBoxFieldValues("lessonTags", defaultParams.lessonTags);
    setSearchBoxFieldValues(
      "organizationalUnitId",
      defaultParams.organizationalUnitId
    );
    setSearchBoxFieldValues("projectNameId", defaultParams.projectNameId);
    setSearchBoxFieldValues("fieldId", defaultParams.fieldId);
  };

  useConstructor(() => {
    //setValuesFromUrl();
  });

  /**
   * Everytime the url changes, re run the search.
   */
  useEffect(() => {
    setValuesFromUrl();
    getLessons();
    getLessonsUrl();
    const tags = createTags();
    setTags(tags);
  }, [searchObject]);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", handleResize);
    if (containerRef && containerRef.current) {
      setContainerHeight(containerRef?.current?.offsetHeight);
    }
    return () => {
      window.removeEventListener("scroll", handleResize);
      lessonStore.setLessonJustAdded(false);
      lessonStore.setLessonJustDeleted(false);
      lessonStore.setLessonJustSaved(false);
    };
  }, []);

  useEffect(() => {
    if (filtersVisible)
      document.getElementById("Lesson-search-filter")?.focus();
  }, [filtersVisible]);

  const handleResize = () => {
    if (containerRef && containerRef.current) {
      let scrollBottom =
        window.scrollY > containerRef?.current?.offsetHeight - 450 &&
        mobileFixed;
      if (scrollBottom) {
        setMobileFixed(false);
      } else if (!scrollBottom) {
        setMobileFixed(true);
      }
    }
  };

  const getLessonsUrl = () => {
    const lessonsUrl = AppStore.siteMapList.find(
      (item) => item.url === decodeURIComponent(location.pathname)
    );
    return setBreadCrumbs(lessonsUrl?.breadCrumbs);
  };

  const swipeableDrawerResizeHandler = (swipeableRef: any) => {
    if (swipeableRef?.current?.parentElement) {
      swipeableRef.current.parentElement.style.borderRadius =
        swipeableRef.current.clientHeight >= window.innerHeight
          ? "0"
          : "20px 20px 0 0";
    }
  };

  const handleTagDelete = (
    fieldName: keyof MultipleValueFields,
    checkboxId: Id
  ) => {
    lessonStore.toggleSearchBoxField(fieldName, checkboxId, false);
    redirect();
  };

  const resetAll = () => {
    setTags([]);
    setTempFreeSearch("");
    resetFields();
  navigate(AppStore.lessonsRoute); 
  };

  const isSearchEmpty = useMemo(() => {
    if (!tags.length && !freeSearch.length) return true;
    return false;
  }, [tags, freeSearch]);

  const resetField = (fieldName: string) => {
    store.resetField(fieldName);
  };

  /**
   * Create tags representing every multiple-value field.
   */
  const createTags = () => {
    const tags: Array<{
      checkboxId: Id;
      checkboxText: string;
      fieldName: keyof MultipleValueFields;
    }> = []; //
    Object.keys(store.search.multipleValueFields).map((fieldName) => {
      const fieldTags = store.search.multipleValueFields[
        fieldName
      ].selectedValues.map((id) => {
        return {
          checkboxId: id,
          checkboxText: store.lists[fieldName].filter(
            (item: ListItem) => item.id == id
          )[0].name,
          fieldName,
        };
      });
      tags.push(...fieldTags);
    });
    return tags;
  };

  const handleProjectTypesChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("projectTypeId", checkboxId, checked);
  };

  const handleLessonTagsChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("lessonTags", checkboxId, checked);
  };

  const handleExternalFactoryInvolvedChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("externalFactorInvolvedId", checkboxId, checked);
  };

  const handleProjectStepsChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("stepId", checkboxId, checked);
  };

  const handleOrganizationalUnitsChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("organizationalUnitId", checkboxId, checked);
  };

  const handleProjectNamesChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("projectNameId", checkboxId, checked);
  };

  const handleProjectPartnersChange = (
    checkboxId: string | number,
    checked: boolean
  ) => {
    store.toggleSearchBoxField("projectPartnerIds", checkboxId, checked);
  };

  const handleFreeSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTempFreeSearch(value);
  };

  const handleFieldsChange = (checkedItems: checkedItemsArr[]) => {
    for (let i = 0; i < checkedItems.length; i++) {
      lessonStore.toggleSearchBoxField(
        "fieldId",
        checkedItems[i].id.toString(),
        checkedItems[i].checked
      );
    }
    if (fieldDropDownIsOpen) {
      setFieldDropDownIsOpen(false);
    }
  };

  const handleFieldDelete = (id: number | string) => {
    let newIds = store.search.multipleValueFields.fieldId.selectedValues.filter(
      (item) => {
        return item !== id;
      }
    );
    store.setFieldId(newIds);
  };

  const handleFreeSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleSubmit();
  };

  const getLessons = async () => {
    try {
      appStore.incrementLoadingProcedure();
      const response = await store.getLessons(appStore.isMobileResolution);
      let totalLessonsCurrentlyLoaded =
        store.search.pageNumber === store.numPages || store.numPages === 0
          ? isApproved
            ? store.lessonsCount
            : store.unApprovedLessonsCount
          : pageNumber * store.search.resultsPerPage;
      setTotalLessonsLoaded(totalLessonsCurrentlyLoaded);
      let showLoadMore = isApproved
        ? totalLessonsCurrentlyLoaded == store.lessonsCount
          ? false
          : true
        : totalLessonsCurrentlyLoaded == store.unApprovedLessonsCount
        ? false
        : true;
      setShowLoadMore(showLoadMore);
    } catch (error: any) {
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setErrorCode(error.statusCode);
      setError(true);
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };

  const acSelectedValues = useMemo(() => {
    return lists.fieldId
      .filter((item) =>
        store.search.multipleValueFields.fieldId.selectedValues.includes(
          item.id.toString()
        )
      )
      .map((i) => ({ text: i.name, value: i.id }));
  }, [store.search.multipleValueFields.fieldId.selectedValues]);

  const handleTabChange = (isApproved: boolean) => {
    resetFields();

    setIsApproved(isApproved);
    redirect();
  };

  const handlePageChange = (page: number) => {
    setPageNumber(page);
    redirect();
  };

  /**
   * Does not invoke any ajax, but changes the url(which in turn causes re-fetch in useEffect). Note that this should be called AFTER the relevant changes to the store have been made.
   */
  const redirect = async () => {
    const searchObject = getSearchObject();
    const queryString = getQueryStringFromObject(searchObject);
    navigate(`${AppStore.lessonsRoute}?` + queryString);
  };

  const handleSubmit = async () => {
    if (filtersVisible) {
      setFiltersVisible(false);
    }
    setFreeSearch(tempFreeSearch);
    setPageNumber(1);
    redirect();
  };

  const deleteLesson = async (id: Id, isMobile: boolean) => {
    try {
      appStore.incrementLoadingProcedure();
      await store.deleteLesson(id, isMobile);
      store.setLessonJustDeleted(true);
    } catch (error: any) {
      if (error.statusCode < 400) {
        setErrorMessage(error.errorMessages);
      } else {
        setErrorMessage(t("GeneralError"));
      }
      setErrorCode(error.statusCode);
      setError(true);
    } finally {
      appStore.decrementLoadingProcedure();
    }
  };

  const redirectToLesson = (url: string) => {
  navigate(`${appStore.lessonsRoute}${url}`);
  };

  const autoScroll = (event: SyntheticEvent) => {
    const position = document.getElementsByTagName("html")[0].scrollTop;
    window.scrollTo(0, position);
  };

  const handleLessonDelete = useCallback(
    (id: Id) => {
      deleteLesson(id, appStore.isMobileResolution);
    },
    [store.lessonsWithReferencedLists]
  );

  const handleLessonClick = useCallback(
    (e: any) => {
      const url = e.currentTarget.id;
      redirectToLesson(url);
    },
    [store.lessonsWithReferencedLists]
  );

  const handleModalStatus = (errorMode: boolean) => {
    setError(errorMode);
  };

  const getCardAriaLabel = (
    lesson: any,
    index: number,
    length: number
  ): string => {
    return (
      t("lesson-view-lesson") +
      " " +
      (index + 1) +
      " " +
      t("Accessibility-from") +
      " " +
      length +
      " " +
      lesson.title
    );
  };

  const renderFiltersSwitch = [];
  for (let i = 0; i < store.lists.order.length; i++) {
    if (store.lists.order[i].show) {
      let type = store.lists.order[i].type;
      switch (type) {
        case "projectTypeId": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="projectTypeId"
              mainText={t("Lesson-project-type")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={projectTypeId.selectedValues}
                onCheck={handleProjectTypesChange}
                items={lists.projectTypeId.filter((type) => type.count > 0)}
              />
            </FilterWrapper>
          );
          break;
        }
        case "lessonTags": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="lessonTags"
              mainText={t("Lesson-tags-header")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={lessonTags.selectedValues}
                onCheck={handleLessonTagsChange}
                items={lists.lessonTags.filter((type) => type.count > 0)}
              />
            </FilterWrapper>
          );
          break;
        }
        case "stepId": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="stepId"
              mainText={t("Lesson-project-step")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={stepId.selectedValues}
                onCheck={handleProjectStepsChange}
                items={lists.stepId.filter((type) => type.count > 0)}
              />
            </FilterWrapper>
          );
          break;
        }
        case "externalFactorInvolvedId": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="externalFactorInvolvedId"
              mainText={t("Lesson-external-factor-involved")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={externalFactorInvolvedId.selectedValues}
                onCheck={handleExternalFactoryInvolvedChange}
                items={lists.externalFactorInvolvedId.filter(
                  (type) => type.count > 0
                )}
              />
            </FilterWrapper>
          );
          break;
        }
        case "organizationalUnitId": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="organizationalUnitId"
              mainText={t("Lesson-organizational-unit-involved")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={organizationalUnitId.selectedValues}
                onCheck={handleOrganizationalUnitsChange}
                items={lists.organizationalUnitId.filter(
                  (type) => type.count > 0
                )}
              />
            </FilterWrapper>
          );
          break;
        }
        case "projectPartnerIds": {
          renderFiltersSwitch.push(
            <FilterWrapper
              fieldName="Lesson-project-partners-label"
              mainText={t("Lesson-project-partners")}
              resetField={resetField}
            >
              <FilterBoxes
                checkedItems={projectPartnerIds.selectedValues}
                onCheck={handleProjectPartnersChange}
                items={lists.projectPartnerIds.filter((type) => type.count > 0)}
              />
            </FilterWrapper>
          );
          break;
        }
      }
    }
  }

  return (
    <div className={`lessons ${style.lessons}`}>
      <SubHeader links={breadCrumbs || []} showBackgroundImage={true} />
      {lessonStore.lessonJustSaved ? (
        <div
          style={{
            position: "sticky",
            zIndex: 999,
            top: appStore.isMobileResolution ? 51 : appStore.headerHeight,
          }}
        >
          <LessonAddedModal
            onClose={() => lessonStore.setLessonJustSaved(false)}
            title={t("Add-lesson-success-title")}
            text={t("Add-lesson-success-text")}
          />
        </div>
      ) : null}
      {lessonStore.lessonJustAdded ? (
        <div
          style={{
            position: "sticky",
            zIndex: 999,
            top: appStore.isMobileResolution ? 51 : appStore.headerHeight,
          }}
        >
          <LessonAddedModal
            onClose={() => lessonStore.setLessonJustAdded(false)}
            title={t("Add-lesson-success-title")}
            text={t("Add-lesson-success-text")}
          />
        </div>
      ) : null}
      {lessonStore.lessonJustDeleted ? (
        <div
          style={{
            position: "sticky",
            zIndex: 999,
            top: appStore.isMobileResolution ? 51 : appStore.headerHeight,
          }}
        >
          <LessonNotification
            onClose={() => lessonStore.setLessonJustDeleted(false)}
            title={t("Lesson-success-deleted-title")}
            text={t("Lesson-success-deleted-text")}
          />
        </div>
      ) : null}
      <div className={style.container} ref={containerRef}>
        <div className={isApproved ? style.content : style.contentNotApproved}>
          <div className={style.content__header}>
            <div className={style.head}>
              {isApproved ? (
               
                <Link
                  aria-label={t("Lesson-search-add")}
                  to={'/מאגר-לקחים/הוספה'}
                >
                  <button
                    className={style.head__button}
                    style={{ position: mobileFixed ? "fixed" : "absolute" }}
                  >
                    <img
                      className={style.head__buttonImage}
                      src={addLesson}
                      alt={t("Lesson-search-add")}
                    />
                    <img
                      className={style.head__buttonImageMobile}
                      src={addLessonMobileIcon}
                      alt={t("Lesson-search-add")}
                    />
                    <div className={style.head__buttonText}>
                      {t("Lesson-search-add")}
                    </div>
                  </button>
                </Link>
              ) : null}
            </div>
          </div>
          <div
            className={
              isApproved
                ? style.contentContainer
                : style.contentContainerNotApproved
            }
          >
            <div className={style.lessonCategory}>
              <div className={style.lessonCategory__main}>
                <button
                  onClick={() => {
                    handleTabChange(true);
                  }}
                  aria-label={t("Lesson-search-approvedTab")}
                >
                  {t("Lesson-search-approvedTab")} ({store.lessonsCount})
                </button>
                {isApproved ? <span className={style.selected} /> : null}
              </div>
              <div className={style.lessonCategory__main}>
                <button
                  onClick={() => {
                    handleTabChange(false);
                  }}
                  aria-label={t("Lesson-search-unApprovedTab")}
                  tabIndex={0}
                >
                  {t("Lesson-search-unApprovedTab")} (
                  {store.unApprovedLessonsCount})
                </button>
                {!isApproved ? <span className={style.selected} /> : null}
              </div>
              {isApproved ? (
                <div className={style.filters__mobile_toggle_wrap}>
                  <button
                    className={style.filters__mobile_toggle}
                    onClick={() => {
                      setFiltersVisible(true);
                    }}
                  >
                    <img alt={t("Lesson-search-filter")} src={filterIcon} />
                  </button>
                </div>
              ) : null}
            </div>
            {!isSearchEmpty && (
              <div className={style.filters}>
                <div className={style.filters__text}>
                  {" "}
                  {t("Lesson-search-sortedBy")}:
                </div>
                {tags.map((tag) => {
                  return (
                    <div
                      onClick={() => {
                        handleTagDelete(tag.fieldName, tag.checkboxId);
                      }}
                      className={style.filters__item__wrapper}
                    >
                      <Chip
                        key={tag.checkboxId}
                        classes={style.filters__item}
                        size="small"
                        label={tag.checkboxText}
                        clickable
                        onDelete={() => {
                          handleTagDelete(tag.fieldName, tag.checkboxId);
                        }}
                        deleteIcon={
                          <img
                            alt="delete"
                            onKeyPress={(key) => {
                              if (key.code === "Enter" || key.code === "Space")
                                handleTagDelete(tag.fieldName, tag.checkboxId);
                            }}
                            tabIndex={0}
                            src={deleteChip}
                          />
                        }
                      />
                    </div>
                  );
                })}

                {tags.length > 2 ? (
                  <span onClick={handlePopoverShowClick} className={style.plus}>
                    <p>{tags.length - 2}</p>
                    <p className={style.plusPlus}>+</p>
                  </span>
                ) : null}
                <Popover
                  id={id_}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handlePopoverClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  PaperProps={{
                    style: {
                      overflow: "visible",
                      color: "rgba(112, 112, 112, 1)",
                      width: "88%",
                      margin: "auto -5px",
                    },
                  }}
                >
                  <Box>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "3px 5px",
                      }}
                    >
                      <button
                        onClick={handlePopoverClose}
                        style={{ opacity: "0.5" }}
                      >
                        x
                      </button>
                    </div>
                    <div className={style.popoverTagWrap}>
                      {tags.slice(2).map((tag) => {
                        return (
                          <div
                            aria-label={tag.checkboxText}
                            tabIndex={0}
                            key={tag.checkboxText}
                            className={style.popoverTag}
                            onClick={() => {
                              handleTagDelete(tag.fieldName, tag.checkboxId);
                            }}
                          >
                            <Chip
                              key={tag.checkboxId}
                              classes={'filters__item'}
                              size="small"
                              label={tag.checkboxText}
                              clickable
                              onDelete={() => {
                                handleTagDelete(tag.fieldName, tag.checkboxId);
                              }}
                              deleteIcon={
                                <img
                                  alt="delete"
                                  tabIndex={0}
                                  onKeyPress={(key) => {
                                    if (
                                      key.code === "Enter" ||
                                      key.code === "Space"
                                    )
                                      handleTagDelete(
                                        tag.fieldName,
                                        tag.checkboxId
                                      );
                                  }}
                                  src={deleteChip}
                                />
                              }
                            />
                          </div>
                        );
                      })}
                    </div>
                  </Box>
                </Popover>

                <button
                  aria-label={t("Lesson-search-resetAll")}
                  onClick={resetAll}
                  className={style.filters__reset}
                >
                  {" "}
                  {t("Lesson-search-resetAll")}
                </button>
              </div>
            )}
            {appStore.showGlobalLoader && <div className={style.placeHolder} />}
            {!appStore.showGlobalLoader &&
              store.lessonsWithReferencedLists.length === 0 && (
                <>{t("Lesson-no-search-results")}</>
              )}
            {!appStore.isMobileResolution &&
              !appStore.showGlobalLoader &&
              store.lessonsWithReferencedLists.length !== 0 &&
              store.lessonsWithReferencedLists.map((lesson, index) => {
                return (
                  <div
                    tabIndex={0}
                    aria-label={getCardAriaLabel(
                      lesson,
                      index,
                      store.lessonsWithReferencedLists.length
                    )}
                    onClick={handleLessonClick}
                    onKeyPress={(key) => {
                      if (key.code === "Enter" || key.code === "Space") {
                        handleLessonClick(key);
                      }
                    }}
                    id={lesson.url}
                    key={lesson.id}
                    className={style.lesson__wrapper}
                  >
                    <Lesson
                      onDelete={handleLessonDelete}
                      showDelete={isApproved ? false :true}
                      showEdit={isApproved ? false :true }
                      lesson={lesson}
                    ></Lesson>
                  </div>
                );
              })}

            {appStore.isMobileResolution &&
              !appStore.showGlobalLoader &&
              store.lessonsMobileWithReferencedLists.length !== 0 &&
              store.lessonsMobileWithReferencedLists.map((lesson) => {
                return (
                  <div
                    aria-label={lesson.title}
                    onClick={handleLessonClick}
                    id={lesson.url}
                    key={lesson.id}
                    className={style.lesson__wrapper}
                  >
                    <Lesson
                      onDelete={handleLessonDelete}
                      showDelete={isApproved ? false :true}
                      showEdit={isApproved ? false :true }
                      lesson={lesson}
                    ></Lesson>
                  </div>
                );
              })}

            {numPages > 0 && !appStore.isMobileResolution && (
              <div className={style.pagination}>
                <Pagination
                  onChange={(e, page) => {
                    handlePageChange(page);
                  }}
                  sx={{
                    "& .MuiPaginationItem-root": {
                      color: "#757575",
                      fontSize: "16px",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "transparent",
                    },
                    "& .Mui-selected": {
                      fontWeight: "bold",
                      color: "black",
                      backgroundColor: "transparent",
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#0077c6",
                    },
                  }}                  page={pageNumber}
                  count={numPages}
                  defaultPage={1}
                />
              </div>
            )}
            {appStore.isMobileResolution && (
              <div
                className={style.loadMoreWrapper}
                style={{ visibility: showLoadMore ? "visible" : "hidden" }}
                ref={loadMoreRef}
              >
                <Button
                  aria-label={t("Lesson-Search-loadMore")}
                  onClick={(event) => {
                    autoScroll(event);
                    handlePageChange(pageNumber + 1);
                  }}
                  variant="empty"
                >
                  ({totalLessonsLoaded} /{" "}
                  {isApproved
                    ? store.lessonsCount
                    : store.unApprovedLessonsCount}
                  ) {t("Lesson-Search-loadMore")}
                </Button>
              </div>
            )}
          </div>
        </div>
        {isApproved && appStore.isMobileResolution && (
          <SwipeableDrawer
            anchor={"bottom"}
            open={filtersVisible}
            onClose={() => setFiltersVisible(false)}
            onOpen={() => {
              setFiltersVisible(true);
              window.scrollTo(0, 0); //doesn't work, try another solution future me.
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <div
              className={style.search_mobile}
              style={{ position: "relative", overflowY: "auto" }}
              ref={mainSwipeableDrawerRef}
              onLoad={() =>
                swipeableDrawerResizeHandler(mainSwipeableDrawerRef)
              }
            >
              <div
                id="Lesson-search-filter"
                tabIndex={0}
                className={style.search_mobile_search}
              >
                <button
                  onClick={() => setFiltersVisible(false)}
                  className={style.delete}
                >
                  <img
                    src={closeBottomSheetIcon}
                    alt={t("Lesson-Search-close-alt")}
                  />
                </button>
                <h2 className={style.search_title}>
                  {t("Lesson-search-filter")}
                </h2>
              </div>
              <div className={style.search__content}>
                <div className={style.search__free}>
                  <div className={style.search__input}>
                    <form onSubmit={handleFreeSearchSubmit}>
                      {tempFreeSearch.length > 0 && (
                        <img
                          src={delSearchIcon}
                          alt={t("Lesson-Search-clearSearch-alt")}
                          onClick={() => setTempFreeSearch("")}
                        />
                      )}
                      <input
                        id="Lesson-search-freeSearch-mobile"
                        name="Lesson-search-freeSearch"
                        aria-label={t("Lesson-search-freeSearch")}
                        value={tempFreeSearch}
                        onChange={handleFreeSearchChange}
                        className={style.search__mainInput}
                        type="text"
                        placeholder={t("Lesson-search-freeSearch")}
                      />
                      <img
                        src={searchIcon}
                        alt={t("Lesson-search-freeSearch")}
                      />
                    </form>
                  </div>
                </div>
                {lists.fieldId.length > 0 ? (
                  <div className={style.search__main}>
                    <div
                      className={
                        fieldIsOpen ? style.fieldIsOpen : style.fieldIsClosed
                      }
                    >
                      <div className={style.domain__header}>
                        <>
                          <p
                            className={style.domain__mainText}
                            onClick={() => setFieldIsOpen(!fieldIsOpen)}
                            tabIndex={0}
                            aria-live="polite"
                            aria-label={
                              t("Search-Filter-Option") +
                              " " +
                              t("Lesson-field") +
                              " " +
                              t("Filter-Closed")
                            }
                            role="button"
                            onKeyPress={(key) => {
                              if (key.code === "Enter" || key.code === "Space")
                                setFieldIsOpen(!fieldIsOpen);
                            }}
                          >
                            {t("Lesson-field")}
                          </p>
                          <img
                            src={
                              !fieldIsOpen
                                ? lesson_toOpenIcon
                                : lesson_toCloseIcon
                            }
                            alt={t("Lesson-Filter-Field")}
                            className={style.closedFieldIcon}
                            onClick={() => setFieldIsOpen(!fieldIsOpen)}
                          />
                        </>
                        {fieldIsOpen && (
                          <button
                            onClick={() => {
                              resetField("fieldId");
                            }}
                            className={style.filters__reset}
                          >
                            {t("Lesson-search-reset")}{" "}
                          </button>
                        )}
                      </div>
                      {fieldIsOpen ? (
                        <div className={style.search__field__wrapper}>
                          <div className={style.search__field}>
                            <FormControl className={style.formControl}>
                              <InputLabel
                                className={style.mobileField__button_open}
                                onClick={() => setFieldDropDownIsOpen(true)}
                              
                                onKeyPress={(event: React.KeyboardEvent) => {
                                  if (event.key === "Enter" || event.key === " ") {  // השתמש ב-event.key במקום event.code
                                    setFieldDropDownIsOpen(true);
                                  }
                                }}
                                id="Lesson-field-label"
                                tabIndex={0}
                              >
                                {t("Lesson-field")}
                                <img
                                  src={lesson_toCloseIcon}
                                  alt={t(
                                    fieldIsOpen
                                      ? "Lesson-Search-Field-close-alt"
                                      : "Lesson-Search-Field-open-alt"
                                  )}
                                  className={style.mobileFieldArrow}
                                  onClick={() => setFieldIsOpen(!fieldIsOpen)}
                                />
                              </InputLabel>
                              {fieldDropDownIsOpen && (
                                <MobileMultDropDown
                                  value={
                                    store.search.multipleValueFields.fieldId
                                      .selectedValues
                                  }
                                  items={lists.fieldId.map((i) => ({
                                    value: i.id,
                                    text: i.name,
                                  }))}
                                  labelId="Lesson-field-label"
                                  onChange={handleFieldsChange}
                                  checkedItems={
                                    store.search.multipleValueFields.fieldId
                                      .selectedValues
                                  }
                                  open={fieldDropDownIsOpen}
                                  title={t("Lesson-field")}
                                  callBackSetter={setFieldDropDownIsOpen}
                                />
                              )}
                            </FormControl>
                          </div>
                          <div className={style.domain__labels}>
                            {fieldId.selectedValues.map((id) => {
                              return (
                                <div key={id} className={style.domain__label}>
                                  <div className={style.domain__labelText}>
                                    {
                                      lists.fieldId.filter((f) => f.id == id)[0]
                                        ?.name
                                    }
                                  </div>
                                  <button
                                    className={style.domain__labelImg}
                                    onClick={() => handleFieldDelete(id)}
                                  >
                                    <img
                                      src={closeLabelIcon}
                                      alt="closeLabel"
                                    />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                {renderFiltersSwitch}
              </div>
              <div className={style.search__bottom}>
                <button onClick={handleSubmit} className={style.bottom__button}>
                  {t("Lesson-search-search")}
                </button>
                <button
                  onClick={resetFields}
                  tabIndex={0}
                  aria-label={t("Lesson-search-reset")}
                  className={style.bottom__reset}
                >
                  {t("Lesson-search-reset")}
                </button>
              </div>
            </div>
          </SwipeableDrawer>
        )}

        {isApproved && !appStore.isMobileResolution && (
          <div className={style.search}>
            <div id="filtersPanel" className={style.search__content}>
              <section className={style.search_inputs_wrap}>
                <div className={style.search__free}>
                  <div className={style.search__input}>
                    <form onSubmit={handleFreeSearchSubmit}>
                      {tempFreeSearch.length > 0 && (
                        <img
                          src={delSearchIcon}
                          alt={t("Lesson-Search-clearSearch-alt")}
                          onClick={() => setTempFreeSearch("")}
                        />
                      )}
                      <input
                        id={"Lesson-search-freeSearch"}
                        name={"Lesson-search-freeSearch"}
                        aria-label={t("Lesson-search-freeSearch")}
                        value={tempFreeSearch}
                        onChange={handleFreeSearchChange}
                        className={style.search__mainInput}
                        type="text"
                        placeholder={t("Lesson-search-freeSearch")}
                      />
                      <img
                        src={searchIcon}
                        alt={t("Lesson-search-freeSearch")}
                      />
                    </form>
                  </div>
                </div>
                {lists.fieldId.length > 0 ? (
                  <div className={style.search__main}>
                    <div
                      className={
                        fieldIsOpen ? style.fieldIsOpen : style.fieldIsClosed
                      }
                    >
                      <div
                        className={style.domain__header}
                        onClick={() => setFieldIsOpen(!fieldIsOpen)}
                      >
                        <img
                          src={
                            !fieldIsOpen
                              ? lesson_toOpenIcon
                              : lesson_toCloseIcon
                          }
                          alt={t("Lesson-Filter-Field")}
                          className={style.closedFieldIcon}
                        />
                        <p
                          className={style.domain__mainText}
                          tabIndex={0}
                          aria-live="polite"
                          aria-label={
                            t("Search-Filter-Option") +
                            " " +
                            t("Lesson-field") +
                            " " +
                            (fieldIsOpen
                              ? t("Filter-Open")
                              : t("Filter-Closed"))
                          }
                          role="button"
                          onKeyPress={(key) => {
                            if (key.code === "Enter" || key.code === "Space")
                              setFieldIsOpen(!fieldIsOpen);
                          }}
                        >
                          {t("Lesson-field")}
                        </p>
                        {fieldIsOpen ? (
                          <button
                            onClick={() => {
                              resetField("fieldId");
                            }}
                            className={style.filters__reset}
                          >
                            {t("Lesson-search-reset")}
                            {""}
                          </button>
                        ) : null}
                      </div>
                      {fieldIsOpen ? (
                        <div className={style.search__field__wrapper}>
                          <Autocomplete
                            multiple
                            id="checkboxes-tags-demo1"
                            options={lists.fieldId.map((i) => ({
                              value: i.id,
                              text: i.name,
                            }))}
                            openOnFocus={true}
                            popupIcon={<DropDownArrow />}
                            limitTags={1}
                            value={acSelectedValues}
                            disableCloseOnSelect
                            isOptionEqualToValue={(option, value) =>
                              option.value == value.value
                            }
                            onChange={(e, selectedItems) => {
                              const checkedIds = selectedItems.map(
                                (i) => i.value
                              ); //Get all checked ids
                              const unCheckedIds = lists.fieldId
                                .map((i) => ({ value: i.id, text: i.name }))
                                .filter(
                                  (val) => !checkedIds.includes(val.value)
                                )
                                .map((i) => i.value); //get all uncheked ids, by comparing the checked ones, to the overall ids.
                              //Needed because the upper api(in lessonStore) relies on it.
                              const checked = checkedIds.map((c) => ({
                                checked: true,
                                id: c,
                              })); //Create "checkedItemsArr"
                              const unchecked = unCheckedIds.map((u) => ({
                                checked: false,
                                id: u,
                              }));

                              handleFieldsChange([...checked, ...unchecked]);
                            }}
                            getOptionLabel={(option) => option.text}
                            renderTags={(values) => (
                              <span className={style.tags}>{`${
                                values[0].text
                              } ${
                                values.length > 1 ? `+${values.length - 1}` : ""
                              }`}</span>
                            )}
                            renderOption={(props, option, { selected }) => {
                              return (
                                <>
                                  <li {...props}>
                                    <input
                                      checked={store.search.multipleValueFields.fieldId.selectedValues.includes(
                                        option.value.toString()
                                      )}
                                      type="checkbox"
                                    />
                                    <span className={style.optionText}>
                                      {option.text}
                                    </span>
                                  </li>
                                  <hr className={style.bottomHr} />
                                </>
                              );
                            }}
                            style={{
                              width: "100%",
                              height: "100%",
                              padding: "20px 0px 20px 0px",
                              textAlign: "right",
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder=""
                                variant="standard"
                              />
                            )}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                {renderFiltersSwitch}
              </section>
              <div className={style.search__bottom}>
                <button onClick={handleSubmit} className={style.bottom__button}>
                  {t("Lesson-search-search")}
                </button>
                <button
                  onClick={() => {
                    resetFields();
                    setTempFreeSearch("");
                  }}
                  role="button"
                  tabIndex={0}
                  aria-label={t("Lesson-search-reset")}
                  className={style.bottom__reset}
                >
                  {t("Lesson-search-reset")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {error ? (
        <CustomModal
          text={errorMessage}
          isOpen={error}
          handleModalStatus={handleModalStatus}
        />
      ) : null}
    </div>
  );
};

export default observer(LessonsPage);
 


